// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__GWVoq","title":"style__title__lh0HI","description":"style__description__bQUk+","component":"style__component__eOxKo"};